import { toNumber2e2hj9zugjwi2 as toNumber } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toJSDate(_this__u8e3s4) {
  return new Date(toNumber(_this__u8e3s4.toEpochMilliseconds_82cfls_k$()));
}
//region block: exports
export {
  toJSDate as toJSDate3pwyd8wp5i7ap,
};
//endregion

//# sourceMappingURL=InstantConversions.mjs.map
